module.exports = __webpack_public_path__ + "img/codigo api correios 6.a41157ce.png";